import React, { Component } from 'react'
import { connect } from 'react-redux'
import SoundboxRendered from 'components/Admin/SoundboxRendered';

import { loadInitialData } from 'redux/actions';

import loading from 'img/loading.png';
import 'css/styles.css';
import 'css/login.css';

class Demo extends Component{

    componentDidMount() {
        this.props.loadInitialData();
    };

    render() {
        if(this.props.loading) {
            return (
                <section id="main" className={'loading'}>
                    <img id={'loading-logo'} src={loading} title={'loading'} alt={'loading'}/>
                </section>
            );
        } else {
            return(
                <section id="main">
                    <SoundboxRendered {...this.props} />
                </section>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return (state);
};

const mapDispatchToProps = { loadInitialData };

export default connect(mapStateToProps, mapDispatchToProps)(Demo);
